import EventManagerMock from './event-manager-mock'

const noop = () => {}

export const isFunction = variable => {
  return !!(variable && variable.constructor && variable.call && variable.apply)
}

const isObject = variable => {
  return Object.prototype.toString.call(variable) === '[object Object]'
}

export const wrapListeners = ({
  listeners,
  dispatch,
  hasParam = false,
  paramMapper = param => param
}) => {
  const generateListener = listener => {
    if (hasParam) {
      return param => {
        listener(paramMapper(param))
      }
    } else {
      return () => {
        listener()
      }
    }
  }

  const generateListenerRedux = listener => {
    if (hasParam) {
      return param => {
        dispatch(listener(paramMapper(param)))
      }
    } else {
      return () => {
        dispatch(listener())
      }
    }
  }

  const wrapSingleListener = listener => {
    if (isObject(listener)) {
      if (listener.redux) {
        return generateListenerRedux(listener.action)
      } else {
        return generateListener(listener.action)
      }
    } else if (isFunction(listener)) {
      return generateListener(listener)
    }
  }

  if (Array.isArray(listeners)) {
    return listeners.map(listener => wrapSingleListener(listener))
  } else if (isFunction(listeners) || isObject(listeners)) {
    return wrapSingleListener(listeners)
  } else {
    console.log('Unknown listener type')
  }

  return noop
}

export const addWorkingStatusCallbacks = (
  eventManager,
  onStartCallback,
  onStopCallback
) => {
  if (eventManager.onStart) {
    if (Array.isArray(eventManager.onStart)) {
      eventManager.onStart.push(onStartCallback)
    } else if (
      isFunction(eventManager.onStart) ||
      isObject(eventManager.onStart)
    ) {
      eventManager.onStart = [
        eventManager.onStart,
        onStartCallback
      ]
    }
  } else {
    eventManager.onStart = onStartCallback
  }

  if (eventManager.onStop) {
    if (Array.isArray(eventManager.onStop)) {
      eventManager.onStop.push(onStopCallback)
    } else if (
      isFunction(eventManager.onStop) ||
      isFunction(eventManager.onStop)
    ) {
      eventManager.onStop = [
        eventManager.onStop,
        onStopCallback
      ]
    }
  } else {
    eventManager.onStop = onStopCallback
  }

  return eventManager
}

export const normaliseEventManager = (eventLM, dispatch) => {
  if (typeof eventLM === 'string') {
    return {
      eventName: eventLM
    }
  }

  return {
    ...eventLM,
    onSuccess: eventLM.onSuccess ? wrapListeners({
      listeners: eventLM.onSuccess,
      dispatch,
      hasParam: true,
      paramMapper: message => message.payload
    }) : noop,
    onError: eventLM.onError ? wrapListeners({
      listeners: eventLM.onError,
      dispatch,
      hasParam: true
    }) : noop,
    onStart: eventLM.onStart ? wrapListeners({
      listeners: eventLM.onStart,
      dispatch
    }) : noop,
    onStop: eventLM.onStop ? wrapListeners({
      listeners: eventLM.onStop,
      dispatch
    }) : noop,
    onAck: eventLM.onAck ? wrapListeners({
      listeners: eventLM.onAck,
      dispatch,
      hasParam: true,
      paramMapper: message => message.payload
    }) : noop,
    onUnregister: eventLM.onUnregister ? wrapListeners({
      listeners: eventLM.onUnregister,
      dispatch
    }) : noop
  }
}

export const createEventManagerMock = () => {
  return new EventManagerMock()
}

export const objectToQueryString = (initialObj) => {
  const reducer = (obj, parentPrefix = null) => (prev, key) => {
    const val = obj[key]
    key = encodeURIComponent(key)
    const prefix = parentPrefix ? `${parentPrefix}[${key}]` : key

    if (val == null || typeof val === 'function') {
      return prev
    }

    if (['number', 'boolean', 'string'].includes(typeof val)) {
      prev.push(`${prefix}=${encodeURIComponent(val)}`)
      return prev
    }

    prev.push(Object.keys(val).reduce(reducer(val, prefix), []).join('&'))
    return prev
  }

  return Object.keys(initialObj).reduce(reducer(initialObj), []).join('&')
}
